import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../store/reducers';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as moment from 'moment';
import { ModuleConfiguration } from '../submission.module.config';
import { JobExportModel } from '../models/JobExportModel';
import { SubmittingEntityListModel } from '../models/SubmittingEntityListModel';
import { JobsService } from '../services/JobsService';

@Component({
  selector: 'brd-job-export-selection-criteria-dialog',
  templateUrl: './job-export-selection-criteria-dialog.component.html',
  styleUrls: ['./job-export-selection-criteria-dialog.component.scss']
})
export class JobExportSelectionCriteriaDialogComponent implements OnInit {
  jobExportModel: JobExportModel;
  exportForm: FormGroup;
  submittingEntities$: Observable<SubmittingEntityListModel[]>;
  exportJobsPermission = 'SubmissionModule.Jobs:Export';

  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<JobExportSelectionCriteriaDialogComponent>,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private actions$: Actions,
    private jobsService: JobsService) {
  
    this.exportForm = this.formBuilder.group({
      startDate: [moment().subtract(1, 'days'), Validators.required],
      endDate: [moment(), Validators.required],
      submittingEntity: [{ key: null, name: 'Select All' }, Validators.required]
    });
  }

  ngOnInit() {
    this.store.dispatch(new dashboardActions.QueryListAction<SubmittingEntityListModel>(ModuleConfiguration.moduleName,
      SubmittingEntityListModel,
      {
        page: 0,
        pageSize: 2000
      }));
    this.submittingEntities$ = this.store.select( fromStore.getSubmittingEntityList );
  }

  export(): void {
    var jobExportModel = this.extractFormValue(this.exportForm);
    this.jobsService.export(jobExportModel).take(1)
      .subscribe(r => {
        this.jobsService.openExtract(r.model.url, r.model);
      });
  }

  itemDisplay(item?: SubmittingEntityListModel): string | undefined {
    return item ? item.name : undefined;
  }

  private extractFormValue(form: any): JobExportModel {
    var jobExportModel = new JobExportModel();
    jobExportModel.startDate = form.value.startDate.format();
    jobExportModel.endDate = form.value.endDate.format();
    jobExportModel.submittingEntityKey = form.value.submittingEntity.key;
    jobExportModel.submittingEntityName = form.value.submittingEntity.name;
    return jobExportModel;
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/components/job-export-selection-criteria-dialog.component.ts